var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, Stack, Text } from "native-base";
import useResponsive from "../util/useResponsive";
const SimpleCard = (_a) => {
    var { children, title } = _a, boxProps = __rest(_a, ["children", "title"]);
    const { isSmallScreen } = useResponsive();
    return isSmallScreen ? (_jsxs(Box, { children: [_jsx(Text, Object.assign({ fontSize: "xs", textTransform: "uppercase", color: "gray.800", fontWeight: "semibold", mb: 3 }, { children: title })), _jsx(Box, Object.assign({ p: 4, borderRadius: "lg", borderColor: "gray.100", borderWidth: 1, borderStyle: "solid", bgColor: "white" }, boxProps, { children: children }))] })) : (_jsxs(Stack, Object.assign({ divider: _jsx(Divider, {}), borderRadius: "lg", borderColor: "gray.100", borderWidth: 1, borderStyle: "solid", bgColor: "white", flex: 1 }, { children: [_jsx(Text, Object.assign({ fontSize: "xs", textTransform: "uppercase", p: 6, color: "black", fontWeight: "bold" }, { children: title })), _jsx(Box, Object.assign({ p: 6 }, boxProps, { children: children }))] })));
};
export default SimpleCard;
